import React, { useEffect, useState } from 'react';
import { TextField } from '@mui/material';
import {
  formatFieldValue,
  parseFieldValue,
  fieldHelperForType,
} from '../common/functionMode';

const isMatrixLikeField = (type) => {
  const t = String(type || '');
  return t.endsWith('[][]') || /^List\s*<\s*List\s*</i.test(t);
};

/**
 * Test-case value field that keeps raw text while focused so the caret
 * is not jumped when array values are parsed/formatted.
 * Commits parsed value on blur (and when draft parses cleanly mid-edit).
 */
const TypedTestCaseField = ({
  type,
  value,
  onChange,
  fieldKey = '',
  sx,
  placeholder,
  ...props
}) => {
  const formatted = formatFieldValue(type, value);
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState('');
  const multiline = isMatrixLikeField(type) || Boolean(props.multiline);

  useEffect(() => {
    setEditing(false);
    setDraft('');
  }, [fieldKey]);

  const displayValue = editing ? draft : formatted;

  const commit = (raw) => {
    const parsed = parseFieldValue(type, raw);
    onChange(parsed);
  };

  return (
    <TextField
      {...props}
      size="small"
      fullWidth
      multiline={multiline}
      minRows={multiline ? 2 : undefined}
      placeholder={placeholder ?? fieldHelperForType(type)}
      value={displayValue}
      onFocus={(event) => {
        setEditing(true);
        setDraft(formatted);
        props.onFocus?.(event);
      }}
      onBlur={(event) => {
        commit(draft);
        setEditing(false);
        setDraft('');
        props.onBlur?.(event);
      }}
      onChange={(event) => {
        const raw = event.target.value;
        setDraft(raw);
        const parsed = parseFieldValue(type, raw);
        // Avoid wiping parent state with null while the user is mid-typing JSON.
        if (parsed !== null || raw.trim() === '') {
          onChange(parsed);
        }
      }}
      sx={sx}
    />
  );
};

export default TypedTestCaseField;
